/**
 * 推荐商品
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/6/28      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */


import React from 'react';
import PropTypes from "prop-types";
import Lang from "@components/Lang/Lang"
import qs from 'query-string';
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import request from "../../../../utils/request";
import Info from "../components/Info";
import {Empty,Spin,Pagination,message,Checkbox,Button,Tabs } from 'antd';
import BuyerInfo from "../components/BuyerInfo";
import Screen from "./components/Screen";
import Item from "./components/Item";
import Cart from "./components/Cart";
import PageCommon from  "@components/PageCommon/PageCommon";
import FactList from "./components/FactList/FactList";
import "./index.less";

class Page extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            activeKey:"1",
            infoLoading:true,
            loading:true,
            list:[],
            model: {},
            value:undefined,
            pagingQuery:{
                pageSize:200, //需求临时说不需要分页，所以后端说这里取一个很大的值
                pageIndex:1,
                total:0
            },
            selectedRowKeys:[],
            count:0,
            //-- 以图搜图相关的 start
            detailRegion:[],
            region:'',
            //截图的坐标
            cutImg:'',
            cutImgData:{},
            imageFileUrl:'',
            //-- 以图搜图相关的 end
            fuzzySampId:(qs.parse(props.location.search) || {}).id
        }
    }
    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref;

    /**
     * 统计
     */
    getCount(){
        $.ajax({
            url: "/service/mg/fuzzy/me-recommend-goods/count",
            type:'post',
            dataType: "json",
            contentType: 'application/json',
            data:JSON.stringify({
                fuzzySampId:this.state.fuzzySampId,
            }),
            success:(res)=>{
                if(res.success&&res.valid){
                    this.setState({
                        count:res.model
                    })
                }
            }
        });
    }

    /**
     * 获取坐标宽高
     * @param obj
     * @return {{w: number, x: *, h: number, y: *}}
     * @private
     */
    _getImgData(obj){
        var x,y,w,h;
        if(obj.region){
            // obj.region (x1,x2,y1,y2)
            let region = obj.region.split(',');
            x = region[0];
            y = region[2];
            w = region[1]-region[0];
            h = region[3]-region[2];
        }
        return {
            x:x,
            y:y,
            w:w,
            h:h,
        }
    }

    /**
     * 找样详情
     **/
    getData(callBack){
        this.setState({
            infoLoading:true
        },()=>{
            let state = {
                infoLoading:false
            }
            request.post(
                "/service/mg/fuzzy/details",
                {
                    id:this.state.fuzzySampId
                }
            ).then((response) => {
                let res = response.data;
                if(res.success&&res.valid){
                    state.model = res.model||{};
                    this.setState(state,()=>{
                        this.onRefPageCommonChild.isShowTop();
                        if(typeof callBack == 'function'){
                            callBack();
                        }
                    })
                }else{
                    state.loading = false;
                    this.setState(state);
                }
            },()=>{
                this.setState(state);
            });
        })
    }

    /**
     * 获取可推荐商品列表的数据
     * @param pageIndex 页码
     * @param data 请求参数
     */
    getGoodsData(pageIndex,data){
        this.setState({
            loading:true,
            selectedRowKeys:[],
            list:[],
        },()=>{
            var postData = Object.assign({
                buyerId:this.state.model.buyerId,
                pageIndex: pageIndex||this.state.pagingQuery.pageIndex,
                pageSize: this.state.pagingQuery.pageSize
            },data);
            var state = {
                loading:false
            };
            $.ajax({
                url: "/service/mg/fuzzy/select/goods-list",
                type:'post',
                dataType: "json",
                contentType: 'application/json',
                data:JSON.stringify(postData),
                success:(res)=>{
                    if(res.success&&res.valid){
                        state.list = res.models||[];
                        (state.list||[]).map((item)=>{
                            item.quantity = item.moq;
                            return item;
                        });
                        state.detailRegion = (res.extra&&res.extra.detailRegion||[]).map((item)=>{
                            let data = this._getImgData(item);
                            item = Object.assign(item,data);
                            return item;
                        });
                        state.region = res.extra&&res.extra.region||{};
                        if(state.cutImg){
                            state.cutImgData = this._getImgData({region:this.state.cutImg});
                        }
                        state.imageFileUrl = res.extra&&res.extra.imageFileUrl;
                    }

                    if(res.paging){
                        state.pagingQuery = {
                            pageIndex:res.paging&&res.paging.pageNum,
                            pageSize:200,
                            total:res.paging&&res.paging.total
                        }
                    }else{
                        state.pagingQuery = {
                            pageIndex:1,
                            pageSize:200,
                            total:0
                        }
                    }
                    this.setState(state);
                },
                error:()=>{
                    this.setState(state);
                }
            });
        })
    }

    /**
     * 切换分页
     * @param page 当前页面
     * @param pageSize 分页大小
     */
    onChangePage = (page, pageSize) => {
        this.setState({
            pagingQuery: {
                pageSize: pageSize,
                pageIndex: page
            }
        }, () => {
            this.getGoodsData()
        })
    }

    /**
     * 修改分页大小
     **/
    onShowSizeChange(current, size){
        this.setState({
            pagingQuery: {
                pageSize: size,
                pageIndex: current
            }
        }, () => {
            this.getGoodsData();
        })
    }

    /**
     * 选择
     * @param selectedRowKeys
     */
    changeSelectedRowKeys(selectedRowKeys){
        this.setState({
            selectedRowKeys:selectedRowKeys
        });
    }

    /**
     * 全选
     **/
    changeSelectedRowKeysAll(){
        let selectedRowKeys = [];
        if(this.state.selectedRowKeys.length!=this.state.list.length){
            (this.state.list||[]).forEach((item)=>{
                selectedRowKeys.push(item.id);
            })
        }
        this.setState({
            selectedRowKeys:selectedRowKeys
        })
    }


    addCart(item){
        var postData = {
            fuzzySampId:this.state.fuzzySampId,
        }
        if(item){
            postData.skuIds = [item.id];
        }else{
            postData.skuIds = this.state.selectedRowKeys;
        }
        $.ajax({
            url: "/service/mg/fuzzy/me-recommend-goods/add",
            type:'post',
            dataType: "json",
            contentType: 'application/json',
            data:JSON.stringify(postData),
            success:(res)=>{
                if(res.success&&res.valid){
                    message.success(__getServerLanguage('JiaRuChengGong'));
                    this.getCount();
                    if(!item){
                        this.setState({
                            selectedRowKeys:[]
                        })
                    }
                }else{
                    message.info(res.message||__getServerLanguage('CaoZuoShiBai'))
                }
            }
        });
    }

    componentDidMount() {
        this.getData(()=>{
            this.getGoodsData();
        });
        this.getCount();
    }

    render(){
        const {model={},list=[],selectedRowKeys=[],activeKey} = this.state;
        const crumb = [
            {name: Lang({id:'ZhaoYangGuanLi',default:"找样管理"}),link:'/customer/fuzzy-task-list'},
            {name: Lang({id:'ZhaoYangXiangQing',default:"找样详情"}),link:`/customer/fuzzy-task-detail?id=${this.state.fuzzySampId}`},
            {name: Lang({id:'TiaoXuanShangPin',default:"挑选商品"})}
        ];
        const {buyerVO={}} = model;
        return (
            <PageCommon onRef={this.onRefPageCommon} showTop={true}>
                <CommonBreadcrumb list={crumb}></CommonBreadcrumb>
                <div className="wp-box">
                    <div className="font_24 font-weight-bold color089 mb_12">{Lang({id:'TiaoXuanShangPin',default:'挑选商品'})}</div>
                    <Spin spinning={this.state.infoLoading}>
                        <Info model={model}
                              fuzzyId={this.state.fuzzySampId}></Info>
                        <BuyerInfo model={model}></BuyerInfo>
                    </Spin>

                    <Spin spinning={this.state.loading}>
                        {/*筛选区*/}
                        <Tabs defaultActiveKey={activeKey} onChange={this.handleChange}
                              items={[
                                  {
                                      key: '1',
                                      label:(Lang({id: "ZhaoShangPin", default: "找商品"})),
                                      children:(<div>
                                          <Screen detailRegion={this.state.detailRegion}
                                                  getImgData={this._getImgData.bind(this)}
                                                  imageFileUrl={this.state.imageFileUrl}
                                                  cutImg={this.state.cutImg}
                                                  cutImgData={this.state.cutImgData}
                                                  handleChange={this.getGoodsData.bind(this)}></Screen>
                                          {/*推荐列表入口*/}
                                          <Cart id={this.state.fuzzySampId}
                                                count={this.state.count}
                                                currencySymbol={buyerVO.currencySymbol}
                                                removeCallBack={this.getCount.bind(this)}></Cart>
                                          {/*可推荐商品列表*/}
                                          <div className="fuzzy-recommend__wrap margin-bottom-16">
                                              <div className="mt_16">
                                                  <Button className="mr_8" disabled={list.length==0}
                                                          onClick={this.changeSelectedRowKeysAll.bind(this)}>
                                                      {
                                                          (list==0||selectedRowKeys.length!=list.length)?
                                                              __getServerLanguage('QuanXuanBenYe')
                                                              :
                                                              __getServerLanguage('QuanBuXuanBenYe')
                                                      }
                                                  </Button>
                                                  <Button disabled={(!selectedRowKeys||selectedRowKeys.length==0)?true:false}
                                                          onClick={()=>{
                                                              this.addCart(null)
                                                          }}>
                                                      {__getServerLanguage('PiLiangJiaRu')}
                                                  </Button>
                                              </div>
                                              {
                                                  list.length==0?
                                                      <Empty className="pt_40 pb_40" description={Lang({id: "ZanWuShuJu", default: "暂无数据"})}></Empty>
                                                      :
                                                      <Checkbox.Group onChange={this.changeSelectedRowKeys.bind(this)}
                                                                      value={this.state.selectedRowKeys}
                                                                      className="fuzzy-recommend__main">
                                                          {
                                                              list.map((item,index)=>{
                                                                  return <Item currencySymbol={buyerVO.currencySymbol} addCart={this.addCart.bind(this)}
                                                                               key={index} item={item}></Item>
                                                              })
                                                          }
                                                      </Checkbox.Group>

                                              }
                                              {/*分页*/}
                                              {
                                                  this.state.pagingQuery.total>0?
                                                      <div className="mt_16 mb_16 text-center pagination-wrap">
                                                          <Pagination
                                                              // showQuickJumper
                                                              showSizeChanger={false}
                                                              // pageSizeOptions={['60','100','200']}
                                                              current={this.state.pagingQuery.pageIndex || 1}
                                                              pageSize={this.state.pagingQuery.pageSize}
                                                              total={this.state.pagingQuery.total || 0}
                                                              // onShowSizeChange={this.onShowSizeChange.bind(this)}
                                                              onChange={this.onChangePage.bind(this)}/>
                                                      </div>
                                                      :
                                                      ''
                                              }
                                          </div>
                                      </div>)
                                  },
                                  {
                                      key: '2',
                                      label:Lang({id: "ZhaoGongChang", default: "找工厂"}),
                                      children:(<FactList />)
                                  }
                              ]}
                        >
                        </Tabs>

                        {/*<Screen detailRegion={this.state.detailRegion}*/}
                                {/*getImgData={this._getImgData.bind(this)}*/}
                                {/*imageFileUrl={this.state.imageFileUrl}*/}
                                {/*cutImg={this.state.cutImg}*/}
                                {/*cutImgData={this.state.cutImgData}*/}
                                {/*handleChange={this.getGoodsData.bind(this)}></Screen>*/}


                    </Spin>
                </div>

            </PageCommon>
        )
    }
}

Page.defaultProps = {
}

Page.propTypes = {

}
export default Page;
